export const mesesAbrev = ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"];

export const meses = [
  "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
  "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro",
];


export const buildMesOptions = (base = new Date()) =>
  Array.from({ length: 6 }, (_, i) => {
    const date = new Date(base.getFullYear(), base.getMonth() - i, 1);
    return {
      value: `${String(date.getMonth() + 1).padStart(2, "0")}/${date.getFullYear()}`,
      label: `${meses[date.getMonth()]}/${date.getFullYear()}`,
    };
  });


export const chaveMes = (iso) => String(iso ?? "").slice(0, 7);

export const chaveMesAnterior = (iso) => {
  const [ano, mes] = chaveMes(iso).split("-").map(Number);
  if (!Number.isInteger(ano) || !Number.isInteger(mes)) return null;
  const anterior = mes === 1 ? { ano: ano - 1, mes: 12 } : { ano, mes: mes - 1 };
  return `${anterior.ano}-${String(anterior.mes).padStart(2, "0")}`;
};


export const buildMesOptionsFromDados = (isoMeses = []) => {
  const chaves = [...new Set(isoMeses.map(chaveMes).filter((c) => /^\d{4}-\d{2}$/.test(c)))]
    .sort()
    .reverse();

  const contiguos = [];
  for (const chave of chaves) {
    const ultimo = contiguos[contiguos.length - 1];
    if (ultimo && chave !== chaveMesAnterior(`${ultimo}-01`)) break;
    contiguos.push(chave);
  }

  if (!contiguos.length) return buildMesOptions();

  return contiguos.map((chave) => {
    const [ano, mes] = chave.split("-");
    return {
      value: `${mes}/${ano}`,
      label: `${meses[Number(mes) - 1]}/${ano}`,
    };
  });
};

const partesMes = (iso) => {
  const [ano, mes] = String(iso ?? "").split("-");
  const idx = Number(mes) - 1;
  if (!ano || Number.isNaN(idx)) return null;
  return { ano, idx };
};

export const formatMes = (iso) => {
  const p = partesMes(iso);
  if (!p) return "";
  return `${mesesAbrev[p.idx]}/${p.ano.slice(2)}`;
};


export const formatMesLong = (iso) => {
  const p = partesMes(iso);
  if (!p) return "";
  return `${meses[p.idx]}/${p.ano}`;
};


export const fmtPct = (v) => {
  if (v == null) return null;
  const sign = v >= 0 ? "+" : "";
  return `${sign}${Number(v).toFixed(1)}%`;
};


export const fmtPctVsM1 = (v) => {
  if (v == null) return null;
  const pct = v * 100;
  const sign = pct >= 0 ? "+" : "";
  return `${sign}${Math.abs(pct) >= 10 ? pct.toFixed(0) : pct.toFixed(1)}% vs M-1`;
};

export const fmtCurrency = (n) =>
  (n ?? 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

export const fmtClientes = (n) => `${n ?? 0} clientes`;


export const nomeProdutoLimpo = (nome) => String(nome ?? "").replace(/^\s*\d+\.\s*/, "").trim();


export const mesParaData = (mes) => {
  const [mm, yyyy] = String(mes ?? "").split("/");
  const ano = Number(yyyy);
  const indice = Number(mm) - 1;
  if (!Number.isInteger(ano) || !Number.isInteger(indice) || indice < 0 || indice > 11) return null;
  return new Date(ano, indice, 1);
};
